import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const toggleButtonFn = /* @__PURE__ */ createRecipe('ToggleButton', {
  "size": "md"
}, [])

const toggleButtonVariantMap = {
  "size": [
    "xs",
    "sm",
    "md",
    "lg"
  ],
  "isRounded": [
    "true"
  ]
}

const toggleButtonVariantKeys = Object.keys(toggleButtonVariantMap)

export const toggleButton = /* @__PURE__ */ Object.assign(memo(toggleButtonFn.recipeFn), {
  __recipe__: true,
  __name__: 'toggleButton',
  __getCompoundVariantCss__: toggleButtonFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: toggleButtonVariantKeys,
  variantMap: toggleButtonVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, toggleButtonVariantKeys)
  },
  getVariantProps: toggleButtonFn.getVariantProps,
})